import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin, FiClock, FiMail } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-luxury-charcoal text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img
              src="https://i.ibb.co/q3wdWB9T/Nashmi-barber-shop-Logo.jpg"
              alt="Nashmi Barber Shop"
              className="h-16 w-16 rounded-full border-2 border-luxury-gold"
            />
            <h3 className="text-luxury-gold font-bold text-xl">Nashmi Barber Shop</h3>
            <p className="text-sm text-gray-300">
              Premium men's grooming services in the heart of Dubai. Experience luxury and precision.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-luxury-gold font-semibold">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'About', path: '/about' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-300 hover:text-luxury-gold transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-luxury-gold font-semibold">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="text-luxury-gold w-4 h-4" />
                <span className="text-sm text-gray-300">Fortune Tower, Cluster C, JLT, Dubai</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-luxury-gold w-4 h-4" />
                <span className="text-sm text-gray-300">+971 50 709 6230</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiClock} className="text-luxury-gold w-4 h-4" />
                <span className="text-sm text-gray-300">Daily: 9:00 AM - 11:00 PM</span>
              </div>
            </div>
          </motion.div>

          {/* Services */}
          <motion.div
            className="space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4 className="text-luxury-gold font-semibold">Our Services</h4>
            <ul className="space-y-2">
              {[
                'Premium Haircuts',
                'Beard Styling',
                'Face Treatments',
                'Hair Washing',
                'Styling & Grooming'
              ].map((service) => (
                <li key={service} className="text-sm text-gray-300">
                  {service}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="mt-8 pt-8 border-t border-luxury-gold/20"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-300">
              © {currentYear} Nashmi Barber Shop. All rights reserved.
            </p>
            <p className="text-sm text-gray-300">
              Domain + Hosting + Design = 
              <a 
                href="https://www.account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-luxury-gold hover:text-luxury-lightGold transition-colors duration-300 ml-1"
              >
                Account4Web Inc
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;